import * as React from "react";
import { cn } from "@/lib/utils";

const TableFooter = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
    <tfoot
        ref={ref}
        className={cn(
            "border-t border-table-border bg-table-footer font-medium [&>tr]:last:border-b-0 [&_tr>td:first-child]:pl-8 [&_tr>td:last-child]:pr-8",
            className,
        )}
        {...props}
    />
));
TableFooter.displayName = "TableFooter";

export { TableFooter };
